import useSubscriptions from "./useSubscriptions";
import SubscriptionColumn from "../../components/general/subscriptionColumn/subscriptionColumn";
import { ISubscriptionPlan } from "../../types/interfaces";
import { Button, Card, Flex, Popconfirm, Skeleton, Tag, Alert } from "antd";
import UploadReceiptModal from "../../components/modals/uploadReceipt";
import {
  PAYMENT_STATUS,
  PAYMENT_STATUS_COLOR,
} from "../../constants/constants";
import { Ban, Upload } from "lucide-react";

function Subscriptions() {
  const {
    data,
    handleCancel,
    handleCancelSubscription,
    handleFileChange,
    handleOk,
    handleSelect,
    loading,
    receiptModal,
    selectedSubscription,
    subscriptionPlan,
    subscription,
    subscriptionLoading,
    uploads,
  } = useSubscriptions();
  return (
    <div>
      <div>
        {subscriptionPlan?.id && !loading ? (
          <>
            <h2 style={{ marginBottom: "12px" }}>Plan actual</h2>
            {subscription?.lastPayment?.status === "pending" && (
              <Alert
                message="Pago pendiente para renovación"
                description={`Tienes hasta el ${subscription?.endDate ? subscription.endDate.replace(/-/g, "/") : "día de corte"} para subir tu comprobante de pago para que tu servicio no sea suspendido.`}
                type="warning"
                showIcon
                style={{ marginBottom: "16px" }}
              />
            )}
            <Card style={{ width: "100%", marginBottom: "16px" }}>
              <Flex justify={"space-between"}>
                <div style={{ width: "50%" }}>
                  <h3>{subscriptionPlan?.name}</h3>
                  <p>{subscriptionPlan?.description}</p>
                </div>

                <div>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#4d4d4d",
                      fontWeight: "bold",
                      marginRight: "12px",
                    }}
                  >
                    Estado de pago:
                  </span>
                  <Tag
                    color={
                      PAYMENT_STATUS_COLOR[subscription?.lastPayment?.status as keyof typeof PAYMENT_STATUS_COLOR]
                    }
                  >
                    {PAYMENT_STATUS[subscription?.lastPayment?.status as keyof typeof PAYMENT_STATUS] ||
                      "Pendiente"}
                  </Tag>
                  <Flex
                    gap={
                      (subscription?.lastPayment?.status === "pending" || subscription?.lastPayment?.status === "failed") ? 12 : 0
                    }
                    style={{ marginTop: "20px" }}
                  >
                    <div>
                      {(subscription?.lastPayment?.status === "pending" || subscription?.lastPayment?.status === "failed") && (
                        <Button
                          onClick={() =>
                            handleSelect(subscriptionPlan.id, true)
                          }
                          style={{
                            borderRadius: "8px",
                          }}
                        >
                          <Upload width={14} /> Subir comprobante
                        </Button>
                      )}
                    </div>
                    <Popconfirm
                      title={"Cancelar subscripción"}
                      description={
                        "Vas a perder acceso a tu plan, estás seguro?"
                      }
                      onConfirm={handleCancelSubscription}
                    >
                      <Button
                        type={"default"}
                        style={{
                          borderRadius: "8px",
                          background: "#fb6767",
                          borderColor: "#fb6767",
                          color: "white",
                        }}
                        // loading={subscriptionLoading.loading}
                      >
                        <Ban width={14} color={"white"} />
                        Cancelar subscripción
                      </Button>
                    </Popconfirm>
                  </Flex>
                </div>
              </Flex>
            </Card>
          </>
        ) : (
          <div></div>
        )}
      </div>
      {loading ? (
        <div>
          <h2 style={{ marginBottom: "12px" }}>Todos los planes</h2>
          <div className={"subscription-container"}>
            <div><Card style={{ height: 400 }}><Skeleton active paragraph={{ rows: 6, width: "100%" }} /></Card></div>
            <div><Card style={{ height: 400 }}><Skeleton active paragraph={{ rows: 6, width: "100%" }} /></Card></div>
            <div><Card style={{ height: 400 }}><Skeleton active paragraph={{ rows: 6, width: "100%" }} /></Card></div>
          </div>
        </div>
      ) : (
        <div style={{ maxWidth: "100%" }}>
          <h2 style={{ marginBottom: "12px" }}>Todos los planes</h2>
          <div className={"subscription-container"}>
            {data?.map((item: ISubscriptionPlan) => {
              return (
                <SubscriptionColumn
                  id={item.id}
                  name={item.name}
                  description={item.description}
                  price={item.price}
                  frequency={item.frequency}
                  permissions={item?.edges?.permissions || []}
                  selectSubscription={handleSelect}
                  key={Math.random()}
                  subscriptionPlanId={subscriptionPlan?.id}
                  userLimit={item?.userLimit}
                />
              );
            })}
          </div>
        </div>
      )}
      <UploadReceiptModal
        isModalOpen={receiptModal.isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        handleFileChange={handleFileChange}
        selectedSubscription={selectedSubscription}
        uploads={uploads}
        loading={subscriptionLoading.loading}
      />
    </div>
  );
}

export default Subscriptions;
